import { Autocomplete } from 'components';
import React, { useEffect, useState } from 'react';
import CaseHandleServices from 'services/CaseHandleServices';

/**
 * SubcategoryStepDropDown - fetches subcategory steps and exposes an Autocomplete.
 */
const SubcategoryStepDropDown = ({
  name,
  label,
  value,
  onChange,
  filter,
  required = false,
  validators = [],
  errorMessages = [],
}) => {
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({ ...filter, search: null, status: 'Active' });

  useEffect(() => {
    setFilters((prev) => ({ ...prev, ...filter, search: prev.search ?? null }));
  }, [filter]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await CaseHandleServices.getAll({ ...filters });
        const list = res?.data?.view?.data || res?.data?.data || res?.data || [];
        const normalized = Array.isArray(list)
          ? list.map((item) => ({
              ...item,
              name: item?.step || item?.name || (item?.subcategory_step?.step) || '',
            }))
          : [];
        setData(normalized);
      } catch (err) {
        // silent
      }
    };

    fetchData();
  }, [filters]);

  return (
    <div>
      <Autocomplete
        name={name}
        label={label}
        value={data.find((item) => item.id === value) || null}
        onChange={(event, newValue) => {
          if (onChange) onChange(event, newValue);
        }}
        options={data}
        getOptionLabel={(option) => option.name || option.step || ''}
        textInputOnChange={(e) => {
          setFilters({ ...filters, search: e.target.value });
        }}
        required={required}
        validators={validators}
        errorMessages={errorMessages}
      />
    </div>
  );
};

export default SubcategoryStepDropDown;
